<template>
    <MainContentTabs
        title="Enviar Boletín"
        :tabs="[
            { nombre: 'Enviar a un grupo', tab: 'enviar' },
            { nombre: 'Enviar una prueba', tab: 'prueba' },
        ]"
        initialTab="enviar"
    >
        <template slot="enviar">
            <b-row>
                <b-col cols="12">
                    <b-alert show variant="secondary">
                        Estás a punto de enviar el boletín {{ boletin_id }} - <b>{{ boletin.asunto }}</b>. Por favor, asegúrate de haberlo revisado cuidadosamente. Después de presionar el botón de enviar, no es posible cambiar el contenido del boletín enviado.
                    </b-alert>
                </b-col>
                <b-col cols="12">
                    <b-button
                        @click="enviar"
                        :disabled="loading"
                    >
                        Enviar boletín
                    </b-button>
                </b-col>
            </b-row>
        </template>
        <template slot="prueba">
            <b-row>
                <b-col cols="12">
                    <label for="emails-test">Enviar prueba a emails:</label>
                    <b-form-textarea
                        id="emails-test"
                        v-model="emails"
                        placeholder="Puedes enviar para múltiples destinatarios, separándolos por comas. Por ejemplo: juan@example.com,maria@example2.com"
                        rows="5"
                        max-rows="10"
                        class="mb-3"
                    />
                </b-col>
                <b-col cols="12">
                    <b-button
                        @click="enviarPrueba"
                        :disabled="emails === '' || loading"
                    >
                        Enviar prueba
                    </b-button>
                </b-col>
            </b-row>
        </template>
    </MainContentTabs>
</template>

<script>
    import apiService from "@/services/api-comunicados";
    import MainContentTabs from '@/components/backend/components/MainContentTabs.vue';

    export default {
        name: 'EnviarBoletin',
        props: {
            boletin_id: {
                type: [Number, String],
                required: true
            }
        },
        data() {
            return {
                emails: '',
                loading: false,
                boletin: {}
            };
        },
        mounted() {
            this.getBoletin();
        },
        methods: {
            async getBoletin() {
                this.loading = true;
                try {
                    const response = await apiService.getBoletin(this.boletin_id);
                    this.boletin = response.data;
                } catch (error) {
                    this.$toast.error("Error al cargar el boletín");
                } finally {
                    this.loading = false;
                }
            },
            async enviarPrueba() {
                try {
                    this.loading = true;
                    const emails_array = this.emails.split(',').map(email => email.trim());
                    await apiService.enviarPruebaBoletin(this.boletin_id, { 'emails': emails_array});
                    this.$toast.success("Prueba enviada correctamente.");
                } catch (error) {
                    this.$toast.error("Error al cargar boletines: " + error.message);
                } finally {
                    this.loading = false;
                }
            },
            async enviar() {
                try {
                    this.loading = true;
                    await apiService.enviarBoletin(this.boletin_id);
                    this.$toast.success("Boletín enviado correctamente.");
                    this.$router.push('/admin/emails/boletines');
                } catch (error) {
                    this.$toast.error("Error al cargar boletines: " + error.message);
                } finally {
                    this.loading = false;
                }
            }
        },
        components: {
            MainContentTabs,
        },
    };
</script>
